export default class TemplateReturnQuestionnaire
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * {string} "left" or "right"
     */
    side =  null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        const ret  = this.v.$store.getters['lensReturn/getReturn'](this.side);

        if(ret)
        {
            return ret.template();
        }

        return true;
    }
}
